package or.app.orientalrecepies.network

import io.ktor.client.HttpClient
import io.ktor.client.plugins.contentnegotiation.ContentNegotiation
import io.ktor.client.plugins.defaultRequest
import io.ktor.client.plugins.HttpTimeout
import io.ktor.client.plugins.observer.ResponseObserver
import io.ktor.client.request.accept
import io.ktor.client.statement.bodyAsText
import io.ktor.client.statement.request
import io.ktor.http.ContentType
import io.ktor.http.content.TextContent
import io.ktor.http.contentType
import io.ktor.serialization.kotlinx.json.json
import kotlinx.serialization.json.Json

object HttpClientProvider {
    val client = HttpClient {
        install(HttpTimeout) {
            requestTimeoutMillis = 300_000 // 5 minuta
            connectTimeoutMillis = 300_000
            socketTimeoutMillis = 300_000
        }

        defaultRequest {
            url("https://api.recipe.car4hire.ba/")
            contentType(ContentType.Application.Json)
            accept(ContentType.Application.Json)
        }

        install(ContentNegotiation) {
            json(Json {
                ignoreUnknownKeys = true
                useAlternativeNames = false
            })
        }

        install(ResponseObserver) {
            onResponse {
                println(
                    """
                    Request: ${it.request.method.value} ${it.status} ${it.request.url}
                    ${(it.request.content as? TextContent)?.text}
                    Response: ${it.bodyAsText()}
                """.trimIndent()
                )

            }
        }
    }
}
